<template>
    <div class="staking-page">
        <div class="header pb-3 pt-3">
          <div class="container">
            <div class="row">
              <div class="col-3 col-md-2 col-lg-1 text-left">
                <div class="row">
                  <div class="col-12">
                    <div class="card icon-card">
                      <div class="row">
                        <div class="col text-center mx-auto">
                          <img src="img/icons/auth_logo.svg" alt="logo" width="50">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-2 col-md-1 col-lg-1">
              </div>
              <div class="col-12 pt-2 col-md-4 offset-lg-7 col-lg-3 text-center">
                <div class="card connect-card" @click="connectWallet">
                  <div class="row h-100">
                    <div class="col-4">
                      <button type="button"
                        class="btn w-100 h-100 connect">
                        <i class="fas fa-wallet"></i>
                      </button>
                    </div>
                    <div v-if="!isConnected" class="col-8 text-left form-inline">
                      {{ $t('general.connect') }}
                    </div>
                    <div v-if="isConnected" class="col-8 text-left form-inline">
                      {{ $t('general.changeWallet') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--<div id="ftab" v-show="sideBar">
          <p class="rotate ctitle" @click="showTutorial">Tutorial</p>
        </div>-->

        <div v-if="!sideBar" class="sticky-video">
          <div class="container h-100">
            <div class="row" style="height: 10%;">
              <div class="col-12 text-center sticky-title">
                <span class="h-100">
                  {{ $t('general.intro')}}
                </span>
                <span class="close-button">
                  <i class="fas fa-times close" @click="hideTutorial"></i>
                </span>
              </div>
            </div>
            <div class="row" style="height: 90%;">
              <div class="col-12 p-0">
                <youtube
                  :video-id='videoId'
                  ref='player'
                  class='video'
                  host='https://www.youtube.com'
                  :player-vars="{ autoplay: 1 }">
                </youtube>
              </div>
            </div>
          </div>
        </div>

        <div class="container">
            <div class="row pb-5">
              <div class="pb-3 pb-md-3 pb-lg-0 col-12 offset-md-2 col-md-8 offset-lg-0 col-lg-4">
                <amount-staked></amount-staked>
              </div>
              <div class="pb-3 pb-md-3 pb-lg-0 col-12 offset-md-2 col-md-8 offset-lg-0 col-lg-4">
                <countdown-until-payout></countdown-until-payout>
              </div>
              <div class="pb-3 pb-md-3 pb-lg-0 col-12 offset-md-2 col-md-8 offset-lg-0 col-lg-4">
                <a-h-t-reward-pool></a-h-t-reward-pool>
              </div>
            </div>
            <div v-if="returnTokens" class="row pb-5">
              <div class="col-12">
                <return-tokens></return-tokens>
              </div>
            </div>
            <div class="row pb-5">
                <div class="pb-3 pb-md-4 pb-lg-0 col-md-12 col-lg-6">
                    <staking-system></staking-system>
                </div>
                <div class="pb-3 pb-md-4 pb-lg-0 col-md-12 col-lg-6">
                    <popular-votes></popular-votes>
                </div>
            </div>
            <div class="row pb-5">
                <div class="col-md-12">
                    <staking-history></staking-history>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Swal from 'sweetalert2'
import AmountStaked from './Staking/AmountStaked'
import CountdownUntilPayout from './Staking/CountdownUntilPayout'
import AHTRewardPool from './Staking/AHTRewardPool'
import StakingSystem from './Staking/StakingSystem'
import PopularVotes from './Staking/PopularVotes'
import StakingHistory from './Staking/StakingHistory'
import ReturnTokens from './Staking/ReturnTokens'

import detectEthereumProvider from '@metamask/detect-provider'
import TrezorConnect, { DEVICE_EVENT, DEVICE } from 'trezor-connect'

import { getIdFromURL } from 'vue-youtube-embed'

export default {
  data () {
    return {
      sideBar: true
    }
  },
  components: {
    AmountStaked,
    CountdownUntilPayout,
    AHTRewardPool,
    StakingSystem,
    PopularVotes,
    StakingHistory,
    ReturnTokens
  },
  computed: {
    amountStaked() {
      return this.$store.getters.getAmountStakedByUser
    },
    isConnected () {
      return this.$store.getters.getIsConnected
    },
    wallet () {
      return this.$store.getters.getWallet
    },
    currentAccount () {
      return this.$store.getters.getAddress
    },
    ahtTokenAddress () {
      return process.env.VUE_APP_AHTTOKEN_ADDRESS
    },
    returnTokens () {
      return this.$store.getters.getShowReturnTokens
    },
    videoId () {
      return getIdFromURL(process.env.VUE_APP_TUTORIAL_LINK)
    }
  },
  methods: {
    async connect() {
      const provider = await detectEthereumProvider()

      if (provider) {
        ethereum
          .request({ method: 'eth_requestAccounts' })
          .then(this.handleAccountsChanged)
          .catch((err) => {
            if (err.code === 4001) {
              console.log('Please connect to MetaMask.')
            } else {
              console.error(err)
            }
          })
      } else {
        Swal.fire({
          title: 'Error',
          text: 'Metamask is not installed or not running',
          icon: 'error',
          confirmButtonText: 'Ok',
          footer: '<a href="https://metamask.io/download.html" target="_blank">Go to Metamask</a>'
        })
        this.$store.dispatch('setIsConnected', false)
      }
    },
    changeWallet() {
      Swal.fire({
        title: this.$t('general.connect'),
        html: `<div class='container-fluid'>
                <div class='row pt-3 pb-3'>
                  <div class='col-12'>
                    <button type='button' class='btn btn-block btn-metamask w-100 wallet'>Metamask</button>
                  </div>
                </div>
                <div class='row pt-3 pb-3'>
                  <div class='col-12'>
                    <button type='button' class='btn btn-block btn-trezor w-100 wallet'>Trezor</button>
                  </div>
                </div>
               </div>`,
        showCloseButton: true,
        showConfirmButton: false,
        willOpen: () => {
          const metamask = document.querySelector('.btn-metamask')
          const trezor = document.querySelector('.btn-trezor')

          metamask.addEventListener('click', () => {
            this.connect()
            Swal.close()
          })

          trezor.addEventListener('click', () => {
            this.connectTrezor()
          })
        }
      })
    },
    connectLedger() {
      console.log('ledger')
    },
    async connectTrezor() {
      let addresses = []
      const { hdkey } = require('ethereumjs-wallet')

      let publicKey  = await TrezorConnect.getPublicKey(
        {
            path: "m/44'/60'/0'/0"
        }
      );

      if (publicKey.success) {
        const walletPub = hdkey.fromExtendedKey(publicKey.payload.xpub)
        for (let idx = 0; idx < 10; idx++) {
          addresses.push(walletPub
            .deriveChild(idx)
            .getWallet()
            .getAddressString())
        }

        this.selectAccount(addresses)
      } else {
        Swal.fire({
          title: 'Error',
          text: 'Trezor connection was unsuccessful',
          icon: 'error',
          confirmButtonText: 'Ok'
        })
      }
    },
    connectTrustwallet() {
      console.log('trustwallet')
    },
    connectWallet() {
      if (this.isConnected) {
        Swal.fire({
          title: this.$t('general.account'),
          html: `<div class='container-fluid'>
                  <div class='row pb-3 pt-2'>
                    <div class='col-12'>
                      Connected with ${this.wallet}
                    </div>
                  </div>
                  <div class='row pb-3 pt-2'>
                    <div class='col-12'>
                      ${
                        this.currentAccount.slice(0,7) + 
                        '............' +
                        this.currentAccount.slice(this.currentAccount.length - 4, this.currentAccount.length)
                      } 
                    </div>
                  </div>
                  <div class='row pb-3 pt-2'>
                    <div class='col-12'>
                      <button type='button' class='btn btn-block btn-change w-100 wallet'>
                        ${ this.$t('general.change') }
                      </button>
                    </div>
                  </div>
                 </div>`,
          showCloseButton: true,
          showConfirmButton: false,
          willOpen: () => {
            const change = document.querySelector('.btn-change')

            change.addEventListener('click', () => {
              this.changeWallet()
            });
          }
        })
      } else {
        this.connect()
      }
    },
    cutAddress(address) {
      return address.slice(0,7) + 
             '............' +
             address.slice(address.length - 4, address.length)
    },
    handleAccountsChanged (accounts) {
      if (accounts.length === 0) {
        this.$store.dispatch('setIsConnected', false)
        console.log('Please connect to MetaMask.')
      } else if (accounts[0] !== this.currentAccount) {
        this.$store.dispatch('setAddress', accounts[0])
        this.$store.dispatch('getAmountStakedByUser', this.currentAccount)
        this.$store.dispatch('setIsConnected', true)
        this.$store.dispatch('setWallet', 0)
        this.$store.dispatch('getVoteInfo', this.currentAccount)
        this.$store.dispatch('getStakingInfo', this.currentAccount)
      } else if (accounts[0] === this.currentAccount && !this.isConnected) {
        this.$store.dispatch('setIsConnected', true)
        this.$store.dispatch('setWallet', 0)
        this.$store.dispatch('getVoteInfo', this.currentAccount)
        this.$store.dispatch('getStakingInfo', this.currentAccount)
      }
    },
    selectAccount(addresses) {
      let options = ''

      for (let i=0; i< addresses.length; i++) {
        options += `<div class='row pb-3 pt-2'>
                      <div class='offset-2 col-8 text-left'>
                        <div class='form-check'>
                          <input class='form-check-input' 
                            type='radio' 
                            name='wallet' 
                            id='${addresses[i]}' 
                            value='${addresses[i]}'
                            ${i === 0 ? 'checked' : ''}>
                          <label class='form-check-label' for='${addresses[i]}'>
                            ${this.cutAddress(addresses[i])}
                          </label>
                        </div>
                      </div>
                    </div>`
      }

      Swal.fire({
        title: this.$t('general.selectAccount'),
        html: `<div class='container-fluid'>
                ${options}
                <div class='row pb-3 pt-2'>
                  <div class='col-12'>
                    <button type='button' class='btn btn-block btn-select-account w-100 wallet'>
                      ${ this.$t('general.change') }
                    </button>
                  </div>
                </div>
               </div>`,
        showCloseButton: true,
        showConfirmButton: false,
        willOpen: () => {
          const select = document.querySelector('.btn-select-account')

          select.addEventListener('click', () => {
            let address = document.querySelector('input[name="wallet"]:checked').value
            this.$store.dispatch('setAddress', address)
            this.$store.dispatch('setWallet', 1)
            this.$store.dispatch('getAmountStakedByUser', this.currentAccount)
            Swal.close()
          })
        }
      })
    },
    startApp (provider) {
      if (provider !== window.ethereum) {
        console.error('Do you have multiple wallets installed?')
        return
      }

      this.connect()
    },
    uniswap () {
      window.open(process.env.VUE_APP_UNISWAP_URL, '_blank');
    },
    showTutorial () {
      this.sideBar = false
    },
    hideTutorial () {
      this.sideBar = true
    }
  },
  async mounted () {
    await this.$store.dispatch('getSurveyActive')
    const provider = await detectEthereumProvider()

    TrezorConnect.on(DEVICE_EVENT, (event) => {
      if (event.type === DEVICE.DISCONNECT) {
        console.log(event)

      }
    });

    if (provider) {
      ethereum.on('accountsChanged', this.handleAccountsChanged)
      setInterval(() => {
        this.$store.dispatch('getAmountStakedByUser', this.currentAccount)
      }, 60000)
    } else {
      Swal.fire({
        title: 'Error',
        text: 'Metamask is not installed or not running',
        icon: 'error',
        confirmButtonText: 'Ok',
        footer: '<a href="https://metamask.io/download.html" target="_blank">Go to Metamask</a>'
      })
      this.$store.dispatch('setIsConnected', false)
      console.log('Metamask is not installed or not running')
    }
  }
}
</script>

<style>
.staking-page p.separator {
  height: 0;
  width: 100%;
  border: 0;
  border-top: 1px solid rgba(255,255,255,.3);
  border-bottom: 2px solid rgba(0,0,0,.5);
  margin-top: .7rem;
}

hr {
  border-top: 1px solid #707070;
  margin-top: 1.2rem;
}

.staking-page {
  background-image: url(/img/theme/asset_1.png);
  background-color: #121212;
  background-repeat: no-repeat;
  color: white;
  background-position: left top;
  background-size: 55% 27%;
}

.staking-page .bh{
  font-weight: 600;
  line-height: 18pt;
  padding-left: 0;
}

.staking-title {
  padding-left: 0;
}

.staking-page .icon-card {
  background: #121212 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 50px #0000001A;
  opacity: 1;
  width: 65px;
  height: 65px;
  border-radius: 18px;
  padding-top: .9rem;
}

.staking-page .connect-card {
  border-color: 1px solid #66c9d8 !important;
  background: #212627 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 50px #0000001A;
  border: 1px solid #61C9D9;
  border-radius: 15px;
  font: normal normal bold 13px Poppins;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
  height: 55px;
  cursor: pointer;
}

.staking-page .connect {
  border-radius: 13px;
  color: white;
  background-color: #61C9D9 !important;
  font-weight: 900;
  font-size: 15px;
}

.staking-page .staking-title {
  font-size: 24px;
}

.staking-page .beta {
  font-size: 10pt;
  color: #1fb5cc;
}

.staking-page .own-risk {
  font-size: 12px;
  text-align: right;
}

.staking-page .aht-votes {
  font-size: 12px;
  color: #1fb5cc;
  text-align: right;
}

.staking-page .aht-address {
  font-size: 11.5px;
  color: #72a5ad;
  text-align: right;
}

.staking-page .uniswap-btn {
  width: 90%;
  border-radius: 7px;
  background: rgb(66,186,43);
  background: linear-gradient(180deg, rgba(66,186,43,1) 0%, rgba(69,243,53,1) 100%);
  font-weight: 900 !important;
  box-shadow: -22px -19px 9px -21px rgba(181,181,181,1), 20px 19px 7px -18px rgba(0,0,0,1);
  border: none;
  height: 85%;
}

.staking-page #ftab {
  width: 1.5em;
  height: 5em;
  position: fixed;
  top: 550px;
  left: 0;
  background-color: #1fb5cc;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  font-size: 20px;
  box-shadow:  1px 1px 3px 0px #401818;
  z-index: 2;
  cursor: pointer;
}

.staking-page .rotate {
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
}

.staking-page .ctitle {
  width: 3.3rem;
  margin-top: 2.5em;
  margin-left: -0.6em;
  letter-spacing: 1px;
  text-shadow: -1px -1px 1px rgba(74, 81, 84, 1);
}

.staking-page .sticky-video {
  position: fixed;
  background-color: #eceae8;
  width: 45vw;
  height: 40%;
  z-index: 2;
  left: 30px;
  bottom: 10px;
}

.staking-page .sticky-close {
  color: #9a9a99;
  cursor: pointer;
}

.staking-page .sticky-title {
  background-color: #eceae8;
  color: #9a9a99;
  font-weight: 400 !important;
}

.staking-page .close-button {
  float: right;
  cursor: pointer;
  font-size: 1.05rem;
}

.staking-page .close {
  color: #9a9a99
}

.staking-page .video,
  .video iframe {
    height: 100%;
    width: 100%;
}

.vb-content-slot {
  overflow: hidden;
}

.swal2-modal {
  color: white;
  background: rgba(32,37,38, 0.6) 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 50px #0000001A;
  backdrop-filter: blur(49px);
  -webkit-backdrop-filter: blur(49px);
}

.swal2-title {
  color: white;  
}

.swal2-content {
  color: white;
}

.swal2-confirm {
  color: white;
  background: rgba(32,37,38, 0.6) 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 50px #0000001A;
  backdrop-filter: blur(49px);
  -webkit-backdrop-filter: blur(49px);
  border-radius: 3px;
}

.swal2-deny {
  color: white;
  background: rgba(32,37,38, 0.6) 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 50px #0000001A;
  backdrop-filter: blur(49px);
  -webkit-backdrop-filter: blur(49px);
  border-radius: 3px;
}

.swal2-footer a {
  color: #72a5ad;
}

.wallet {
  width: 90%;
  border-radius: 3px;
  color: white;
  background: rgb(26,161,181);
  background: linear-gradient(357deg, rgba(26,161,181,1) 0%, rgba(0,222,255,1) 100%);
  font-weight: 900;
  font-size: 15px;
  box-shadow: -22px -19px 9px -21px rgba(181,181,181,1), 20px 19px 7px -18px rgba(0,0,0,1);
  border: none;
  height: 2.7rem;
}

.wallet:hover {
  color: white;
}

.card-amount-responsive {
  font-size: calc(1.4rem + 1.5vw) !important;
}

/* Loading circle style */
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
